<template>
  <div
    class="bigdata_container"
    id="bigdata"
    v-loading="isLoading"
    element-loading-text="拼命加载中..."
    element-loading-background="rgba(0, 0, 0, 0.6)"
  >
    <div id="container" class="mymap" style="width: 100%; height: 100%"></div>
      <div class="top-menu flex-item">
        <div class="flex-item l1">
          <div>
            <p>
              <img
                src="./assets/big/oldIcon1.png"
                alt=""
                srcset=""
              />{{ targetName? targetName:'绩溪县'}}常住人口
            </p>
            <p class="nums">{{ changzhu }}</p>
            <!-- <p class="nums">{{ peopleList.permanent }}</p> -->
          </div>

          <div>
            <p>
              <img
                src="./assets/big/oldIcon2.png"
                alt=""
                srcset=""
              />{{ targetName? targetName:'绩溪县'}}家庭户
            </p>
            <p class="nums">{{ huji }}</p>
            <!-- <p class="nums">{{ peopleList.householdRegistration }}</p> -->

          </div>
        </div>
        <div class="flex-item l2" style="width: 50%">
          <div>
            <p class="nums color-l">41698</p>
            <!-- {{ peopleList.totalCount || 0}} -->
            <p>60岁以上(人)</p>
          </div>
          <div >
            <p class="nums color-z">30864</p>
            <!-- {{ peopleList.sixtyToEightyNine || 0}} -->
            <p>65岁以上(人)</p>
          </div>
          <div >
            <p class="nums color-h">962</p>
            <!-- {{ peopleList.ninetyToNinetyFour || 0}} -->
            <p>90岁以上(人)</p>
          </div>
          <!-- <div>
            <p class="nums color-l"></p>
            <!-- {{ peopleList.ninetyFiveToninetyNine || 0}}
            <p>95-99岁以上(人)</p>
          </div> -->
          <div
            @click="getoldPeople(5)"
            class="shubaio"
          >
            <p class="nums color-q">12</p>
            <p>100岁以上(人)</p>
          </div>
        </div>
        <div class="flex-item l3" style="width: 20%">
          <div class="shubaio" @click="gethelpPeople(1)">
            <p class="nums color-z">412</p>
            <p>特困老人</p>
          </div>
          <div class="shubaio" @click="gethelpPeople(2)">
            <p class="nums color-g">1146</p>
            <p>低保老人</p>
          </div>
          <div class="shubaio" @click="gethelpPeople(3)">
            <p class="nums color-l">2840</p>
            <p>残疾老人</p>
          </div>
        </div>
      </div> 
    <div class="oldRight">
        <div class="area">
          <!-- aactive -->
          <div
            @click="changeArea(index, item)"
            :class="{ aactive: activeIndex == index }"
            v-for="(item, index) in listArea"
            :key="index"
          >
            {{ item }}
          </div>
        </div>
        <!-- 老年社区 -->
        <div class="oldBox">
          <div class="leftTitle">{{ targetName? targetName:''}}老年人数量</div>
          <div id="oldNums"></div>
        </div>
        <!-- 人口比例数 -->
        <div class="oldBox">
          <div class="leftTitle">{{ targetName? targetName:''}}人口比例数</div>
          <div class="percentBox">
            <div class="percentItem">
              <p class="percentTitle">年龄段分析</p>
              <div id="agePercent"></div>
              <div class="mallNote">
                <ul>
                  <li>
                    <span class="icon icon1"></span
                    ><span class="name">60-64岁</span>
                  </li>
                  <li>
                    <span class="icon icon3"></span
                    ><span class="name">60-89岁</span>
                  </li>
                </ul>
                <ul>
                  <li>
                    <span class="icon icon4"></span
                    ><span class="name">95-99岁以上</span>
                  </li>
                  <li>
                    <span class="icon icon5"></span
                    ><span class="name">100岁以上</span>
                  </li>
                </ul>
              </div>
            </div>
            <div class="percentItem">
              <p class="percentTitle">健康分析</p>
              <div id="healthPercent"></div>
              <div class="mallNote" style="margin-top: -70px">
                <ul>
                  <li>
                    <span class="icon" style="background: #f21b62"></span
                    ><span class="name">高血压</span>
                  </li>
                  <li>
                    <span class="icon" style="background: #7fd42d"></span
                    ><span class="name">脑血管疾病</span>
                  </li>
                  <li>
                    <span class="icon" style="background: #22f7ff"></span
                    ><span class="name">肾脏疾病</span>
                  </li>
                </ul>
                <ul>
                  <li>
                    <span class="icon" style="background: #0f5bf5"></span
                    ><span class="name">糖尿病</span>
                  </li>
                  <li>
                    <span class="icon" style="background: #d800ff"></span
                    ><span class="name">血管疾病</span>
                  </li>
                  <li>
                    <span class="icon" style="background: #2372be"></span
                    ><span class="name">心脏病</span>
                  </li>
                </ul>
                <ul>
                  <li>
                    <span class="icon" style="background: #ffb026"></span
                    ><span class="name">眼部疾病</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
    </div>
     <!-- 百岁老人信息弹窗 -->
      <div class="perInfoBox" v-if="showInfoPer1">
        <div class="info-txt" style="background-color:rgba(10, 88, 160, 0.8)">
          <div class="info-item" >
            <p class="intitle" style="margin-bottom: 15px; font-size:20px;">人员信息</p>
            <div style="align-items: center;height: 200px; background-color: #162A5B" >
              <p style="font-size:18px;padding:10px">基本信息</p>
              <div>
                <div style="width: 120px; height: 120px; margin-right: 20px; float: right">
                  <!-- <img
                    style="width: 100%; height: 100%"
                    :src='peopleInfo.photoUrl'
                    alt=""
                  /> -->
                </div>
              <div>
                  <div style="padding: 10px;width:500px">
                    <label for="">姓名：</label>{{ peopleInfo.name }}
                    <span style="margin-left:20px">
                      <label for="">姓别：</label
                      >{{ peopleInfo.sex}}
                    </span>
                    <span style="margin-left:20px"><label for="">年龄：</label>{{ peopleInfo.age }}岁</span>
                    <p>
                      <label for="">联系方式：</label>{{ peopleInfo.phone }}
                      <!-- <span style="margin-left:20px"><label for="">所属社区：</label>{{ peopleInfo.communityName }}</span> -->
                    </p>
                    <p>
                      <label for="">所属类型：百岁老人</label>
                      <!-- <span style="margin-left:20px"><label for="">健康分析：</label></span> -->
                    </p>
                    <p>
                      <label for="">家庭地址：</label>{{ peopleInfo.censusRegister }}
                    </p>
                    <!-- <span style="margin-left:10px"><label for="">所属社区：</label>{{ peopleInfo.communityName }}</span>
                    <span style="margin-left:10px"><label for="">家庭住址：</label>{{ peopleInfo.nation }}</span> -->
                  </div>
                </div>
              </div>
              
            </div>
          </div>
          <div class="info-item">
            <p class="intitle">家庭成员信息</p>
            <div style="background-color: #162A5B">
              <p style="width:100%; height: 169px" class="tableBox">
                <el-table
                    :data="housePeopleList"
                    bgcolor="#01117b"
                    border
                    style="width: 100%;height:100%;overflow-y: scroll;"
                >
                    <el-table-column
                        type="index"
                        width="70"
                        label="序号"
                        align="center"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        label="姓名"
                        :show-overflow-tooltip="true"
                        align="center"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="phone"
                        label="电话"
                        align="center"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="relationship"
                        align="center"
                        :show-overflow-tooltip="true"
                        label="与老人关系"
                    >
                    </el-table-column>
                </el-table>
              </p>
              
              <!-- <p style="width: 33%">
                <label for="">户籍：</label
                >{{ peopleInfo.lifeArea == 1 ? "城市户口" : "农村户口" }}
              </p>
              <p style="width: 33%"><label for="">保障：</label>XXXXXXXXXXX</p>
              <p style="width: 33%"><label for="">低保原因：</label>孤独老人</p> -->
            </div>
          </div>
          <div class="info-item">
            <!-- <p class="intitle">特困信息</p> -->
            <div  style="display:flex;justify-content: space-around; height: 220px">
              <div style=" width: 30%">
                <p style="text-align:center">帮扶信息</p>
                <div style="height:223px;background: #162A5B;">
                  {{ peopleInfo.assistanceProgram }}
                </div>
              </div>
              <div style=" width: 30%">
                <p style="text-align:center">社区活动</p>
                <div style="height:223px;background: #162A5B;">
                  <div class="activeList2">
                      <div class="ac-title2" style="display: flex">
                        <div style="width: 50px">序号</div>
                        <div style="flex: 1">活动类型</div>
                        <div style="flex: 1">活动名称</div>
                      </div>
                      <div
                          class="houseContent"
                          style="height: 620px; overflow: scroll"
                        >
                        <vue-seamless-scroll
                          :style="{
                            height: this.scrollHeight + 'px',
                          }"
                          :data="tableActive"
                          :class-option="defaultOption"
                          class="warp-content"
                        >
                          <div
                            class="ac-item"
                            style="display: flex"
                            v-for="(item, index) in tableActive"
                            :key="index"
                            @click="getactiveInfo(item)"
                          >
                            <div style="width: 50px">{{ index + 1 }}</div>
                            <div
                              style="
                                flex: 1;
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                              "
                            >
                              <span v-if="item.type == 1">图文</span>
                              <span v-if="item.type == 2">视频</span>
                            </div>
                            <div style="flex: 1;width: 160px; overflow: hidden; text-overflow:ellipsis; white-space: nowrap;">
                              <el-tooltip class="item" effect="dark" :content="item.name" placement="top">
                                <span>{{ item.name }}</span>
                              </el-tooltip>
                                
                                
                            </div>
                          </div>
                        </vue-seamless-scroll>
                      </div>
                    </div>
                </div>
              </div>
              <div style=" width: 30%">
                <p style="text-align:center">活动计划</p>
                <div style="height:223px;background: #162A5B;">
                  <div class="activeList2">
                    <div class="ac-title2" style="display: flex">
                      <div style="width: 50px">序号</div>
                      <div style="flex: 1">活动名称</div>
                      <div style="flex: 1">活动内容</div>
                      <div style="flex: 1">活动时间</div>
                    </div>
                    <div
                        class="houseContent"
                        style="height: 620px; overflow: scroll"
                      >
                      <vue-seamless-scroll
                        :style="{
                          height: this.scrollHeight + 'px',
                        }"
                        :data="tablePlan"
                        :class-option="defaultOption"
                        class="warp-content"
                      >
                        <div
                          class="ac-item"
                          style="display: flex"
                          v-for="(item, index) in tablePlan"
                          :key="index"
                          
                        >
                          <div style="width: 50px">{{ index + 1 }}</div>
                          <div style="flex: 1;width: 160px; overflow: hidden; text-overflow:ellipsis; white-space: nowrap;">{{ item.name }}</div>
                          <div style="flex: 1;width: 160px; overflow: hidden; text-overflow:ellipsis; white-space: nowrap;">{{ item.content }}</div>
                          <div style="flex: 1;width: 160px; overflow: hidden; text-overflow:ellipsis; white-space: nowrap;">{{ item.activityTime }}</div>
                        </div>
                      </vue-seamless-scroll>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="info-item">
            <p class="intitle">两残补贴信息</p>
            <p style="width: 33%"><label for="">残疾等级：</label>孤独老人</p>
          </div>
          <div class="info-item">
            <p class="intitle">社区活动</p>
            <div>
              <iframe
                src="https://open.ys7.com/ezopen/h5/iframe_se?url=ezopen://open.ys7.com/E60167235/3.live&autoplay=1&audio=1&accessToken=at.91ryaacu4px3vufc64aqwf9ndpl3k7gk-67w5hvxb6i-0caeunm-8trebo2cf&templete=2"
                width="400"
                height="200"
                id="ysopen"
                allowfullscreen
              >
              </iframe>
            </div>
          </div> -->
          <span class="close-info" @click="showInfoPer1 = false">×</span>
        </div>
      </div>
    <!-- 特困老人 -->
      <div class="perInfoBox" v-if="showInfoPer2">
        <div class="info-txt" style="background-color:rgba(10, 88, 160, 0.8)">
          <div class="info-item" >
            <p class="intitle" style="margin-bottom: 15px; font-size:20px;">人员信息</p>
            <div style="align-items: center;height: 200px; background-color: #162A5B" >
              <p style="font-size:18px;padding:10px">基本信息</p>
              <div>
                <div style="width: 120px; height: 120px; margin-right: 20px; float: right">
                  <!-- <img
                    style="width: 100%; height: 100%"
                    :src='peopleInfo.photoUrl'
                    alt=""
                  /> -->
                </div>
              <div>
                  <div style="padding: 10px;width:500px">
                    <label for="">姓名：</label>{{ peopleInfo.name }}
                    <span style="margin-left:20px">
                      <label for="">姓别：</label
                      >{{ peopleInfo.sex == 1 ? "男" : "女" }}
                    </span>
                    <span style="margin-left:20px"><label for="">年龄：</label>{{ peopleInfo.age }}岁</span>
                    <p>
                      <label for="">联系方式：</label>{{ peopleInfo.phone }}
                      <!-- <span style="margin-left:20px"><label for="">所属社区：</label>{{ peopleInfo.communityName }}</span> -->
                    </p>
                    <p>
                      <label for="">所属类型：特困老人</label>
                      <!-- <span style="margin-left:20px"><label for="">健康分析：</label></span> -->
                    </p>
                    <p>
                      <label for="">家庭地址：</label>{{ peopleInfo.censusRegister }}
                    </p>
                  </div>
                </div>
              </div>
              
            </div>
          </div>
          <div class="info-item">
            <p class="intitle">五方协议</p>
            <div style="background-color: #162A5B">
              <p style="width:100%; height: 169px">
                <el-upload
                  class="upload-demo"
                  :action="actionUrl"
                  :on-remove="handleRemove"
                  :before-remove="beforeRemove"
                  :on-preview="handlePreview"
                  :on-success="fileSuccess"
                  multiple
                  :limit="9"
                  :on-exceed="handleExceed"
                  :file-list="filing"
              >
                  <!-- <el-button size="small" type="primary">点击上传</el-button> -->
              </el-upload>
              </p>
            </div>
          </div>
          <div class="info-item">
            <div  style="display:flex;justify-content: space-around; height: 220px">
              <div style=" width: 30%">
                <p style="text-align:center">帮扶信息</p>
                <div style="height:223px;background: #162A5B;">
                  {{ peopleInfo.assistanceProgram }}
                </div>
              </div>
              <div style=" width: 30%">
                <p style="text-align:center">社区活动</p>
                <div style="height:223px;background: #162A5B;">
                  <div class="activeList2">
                    <div class="ac-title2" style="display: flex">
                      <div style="width: 50px">序号</div>
                      <div style="flex: 1">活动类型</div>
                      <div style="flex: 1">活动名称</div>
                    </div>
                    <div
                        class="houseContent"
                        style="height: 620px; overflow: scroll"
                      >
                      <vue-seamless-scroll
                        :style="{
                          height: this.scrollHeight + 'px',
                        }"
                        :data="tableActive1"
                        :class-option="defaultOption"
                        class="warp-content"
                      >
                        <div
                          class="ac-item"
                          style="display: flex"
                          v-for="(item, index) in tableActive1"
                          :key="index"
                          @click="getactiveInfo(item)"
                        >
                          <div style="width: 50px">{{ index + 1 }}</div>
                          <div
                            style="
                              flex: 1;
                              white-space: nowrap;
                              overflow: hidden;
                              text-overflow: ellipsis;
                            "
                          >
                            <span v-if="item.type == 1">图文</span>
                            <span v-if="item.type == 2">视频</span>
                          </div>
                          <div style="flex: 1;width: 160px; overflow: hidden; text-overflow:ellipsis; white-space: nowrap;">
                            <el-tooltip class="item" effect="dark" :content="item.name" placement="top">
                              <span>{{ item.name }}</span>
                            </el-tooltip>
                              
                              
                          </div>
                        </div>
                      </vue-seamless-scroll>
                    </div>
                  </div>
                </div>
              </div>
              <div style=" width: 30%">
                <p style="text-align:center">活动计划</p>
                <div style="height:223px;background: #162A5B;">
                  <div class="activeList2">
                    <div class="ac-title2" style="display: flex">
                      <div style="width: 50px">序号</div>
                      <div style="flex: 1">活动名称</div>
                      <div style="flex: 1">活动内容</div>
                      <div style="flex: 1">活动时间</div>
                    </div>
                    <div
                        class="houseContent"
                        style="height: 620px; overflow: scroll"
                      >
                      <vue-seamless-scroll
                        :style="{
                          height: this.scrollHeight + 'px',
                        }"
                        :data="tablePlan1"
                        :class-option="defaultOption"
                        class="warp-content"
                      >
                        <div
                          class="ac-item"
                          style="display: flex"
                          v-for="(item, index) in tablePlan1"
                          :key="index"
                          
                        >
                          <div style="width: 50px">{{ index + 1 }}</div>
                          <div style="flex: 1;width: 160px; overflow: hidden; text-overflow:ellipsis; white-space: nowrap;">{{ item.name }}</div>
                          <div style="flex: 1;width: 160px; overflow: hidden; text-overflow:ellipsis; white-space: nowrap;">{{ item.content }}</div>
                          <div style="flex: 1;width: 160px; overflow: hidden; text-overflow:ellipsis; white-space: nowrap;">{{ item.activityTime }}</div>
                        </div>
                      </vue-seamless-scroll>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <span class="close-info" @click="showInfoPer2 = false">×</span>
        </div>
      </div>
    <!-- 低保老人 -->
      <div class="perInfoBox" v-if="showInfoPer3">
        <div class="info-txt" style="background-color:rgba(10, 88, 160, 0.8)">
          <div class="info-item" >
            <p class="intitle" style="margin-bottom: 15px; font-size:20px;">人员信息</p>
            <div style="align-items: center;height: 200px; background-color: #162A5B" >
              <p style="font-size:18px;padding:10px">基本信息</p>
              <div>
                <div style="width: 120px; height: 120px; margin-right: 20px; float: right">
                  <!-- <img
                    style="width: 100%; height: 100%"
                    :src='peopleInfo.photoUrl'
                    alt=""
                  /> -->
                </div>
              <div>
                  <div style="padding: 10px;width:500px">
                    <label for="">姓名：</label>{{ peopleInfo.name }}
                    <span style="margin-left:20px">
                      <label for="">姓别：</label
                      >{{ peopleInfo.sex == 1 ? "男" : "女" }}
                    </span>
                    <span style="margin-left:20px"><label for="">年龄：</label>{{ peopleInfo.age }}岁</span>
                    <p>
                      <label for="">联系方式：</label>{{ peopleInfo.phone }}
                      <!-- <span style="margin-left:20px"><label for="">所属社区：</label>{{ peopleInfo.communityName }}</span> -->
                    </p>
                    <p>
                      <label for="">所属类型：低保老人</label>
                      <!-- <span style="margin-left:20px"><label for="">健康分析：</label></span> -->
                    </p>
                    <p>
                      <label for="">家庭地址：</label>{{ peopleInfo.censusRegister }}
                    </p>
                  </div>
                </div>
              </div>
              
            </div>
          </div>
          <div class="info-item">
            <p class="intitle">低保信息</p>
            <div style="background-color: #162A5B">
              <p style="width:100%; height: 169px">
                {{ peopleInfo.fidelityReason }}
              </p>
            </div>
          </div>
          <div class="info-item">
            <div  style="display:flex;justify-content: space-around; height: 220px">
              <div style=" width: 30%">
                <p style="text-align:center">帮扶信息</p>
                <div style="height:190px;background: #162A5B;">
                  {{ peopleInfo.assistanceProgram }}
                </div>
              </div>
              <div style=" width: 30%">
                <p style="text-align:center">社区活动</p>
                <div style="height:190px;background: #162A5B;">
                  <div class="activeList2">
                    <div class="ac-title2" style="display: flex">
                      <div style="width: 50px">序号</div>
                      <div style="flex: 1">活动类型</div>
                      <div style="flex: 1">活动名称</div>
                    </div>
                    <div
                        class="houseContent"
                        style="height: 620px; overflow: scroll"
                      >
                      <vue-seamless-scroll
                        :style="{
                          height: this.scrollHeight + 'px',
                        }"
                        :data="tableActive2"
                        :class-option="defaultOption"
                        class="warp-content"
                      >
                        <div
                          class="ac-item"
                          style="display: flex"
                          v-for="(item, index) in tableActive2"
                          :key="index"
                          @click="getactiveInfo(item)"
                        >
                          <div style="width: 50px">{{ index + 1 }}</div>
                          <div
                            style="
                              flex: 1;
                              white-space: nowrap;
                              overflow: hidden;
                              text-overflow: ellipsis;
                            "
                          >
                            <span v-if="item.type == 1">图文</span>
                            <span v-if="item.type == 2">视频</span>
                          </div>
                          <div style="flex: 1;width: 160px; overflow: hidden; text-overflow:ellipsis; white-space: nowrap;">
                            <el-tooltip class="item" effect="dark" :content="item.name" placement="top">
                              <span>{{ item.name }}</span>
                            </el-tooltip>
                              
                              
                          </div>
                        </div>
                      </vue-seamless-scroll>
                    </div>
                  </div>
                </div>
              </div>
              <div style=" width: 30%">
                <p style="text-align:center">活动计划</p>
                <div style="height:190px;background: #162A5B;">
                  <div class="activeList2">
                    <div class="ac-title2" style="display: flex">
                      <div style="width: 50px">序号</div>
                      <div style="flex: 1">活动名称</div>
                      <div style="flex: 1">活动内容</div>
                      <div style="flex: 1">活动时间</div>
                    </div>
                    <div
                        class="houseContent"
                        style="height: 620px; overflow: scroll"
                      >
                      <vue-seamless-scroll
                        :style="{
                          height: this.scrollHeight + 'px',
                        }"
                        :data="tablePlan2"
                        :class-option="defaultOption"
                        class="warp-content"
                      >
                        <div
                          class="ac-item"
                          style="display: flex"
                          v-for="(item, index) in tablePlan2"
                          :key="index"
                          
                        >
                          <div style="width: 50px">{{ index + 1 }}</div>
                          <div style="flex: 1;width: 160px; overflow: hidden; text-overflow:ellipsis; white-space: nowrap;">{{ item.name }}</div>
                          <div style="flex: 1;width: 160px; overflow: hidden; text-overflow:ellipsis; white-space: nowrap;">{{ item.content }}</div>
                          <div style="flex: 1;width: 160px; overflow: hidden; text-overflow:ellipsis; white-space: nowrap;">{{ item.activityTime }}</div>
                        </div>
                      </vue-seamless-scroll>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <span class="close-info" @click="showInfoPer3 = false">×</span>
        </div>
      </div>
      <!-- 两残补贴 -->
      <div class="perInfoBox" v-if="showInfoPer4">
        <div class="info-txt" style="background-color:rgba(10, 88, 160, 0.8)">
          <div class="info-item" >
            <p class="intitle" style="margin-bottom: 15px; font-size:20px;">人员信息</p>
            <div style="align-items: center;height: 200px; background-color: #162A5B" >
              <p style="font-size:18px;padding:10px">基本信息</p>
              <div>
                <div style="width: 120px; height: 120px; margin-right: 20px; float: right">
                  <!-- <img
                    style="width: 100%; height: 100%"
                    :src='peopleInfo.photoUrl'
                    alt=""
                  /> -->
                </div>
              <div>
                  <div style="padding: 10px;width:500px">
                    <label for="">姓名：</label>{{ peopleInfo.name }}
                    <span style="margin-left:20px">
                      <label for="">姓别：</label
                      >{{ peopleInfo.sex == 1 ? "男" : "女" }}
                    </span>
                    <span style="margin-left:20px"><label for="">年龄：</label>{{ peopleInfo.age }}岁</span>
                    <p>
                      <label for="">联系方式：</label>{{ peopleInfo.phone }}
                      <!-- <span style="margin-left:20px"><label for="">所属社区：</label>{{ peopleInfo.communityName }}</span> -->
                    </p>
                    <p>
                      <label for="">所属类型：两残</label>
                      <!-- <span style="margin-left:20px"><label for="">健康分析：</label></span> -->
                    </p>
                    <p>
                      <label for="">家庭地址：</label>{{ peopleInfo.censusRegister }}
                    </p>
                  </div>
                </div>
              </div>
              
            </div>
          </div>
          <div class="info-item">
            <p class="intitle">残疾类别和等级</p>
            <div style="background-color: #162A5B">
              <p style="width:100%; height: 169px; padding: 0px 0 0 20px">
                <span v-if="peopleInfo.disabilityLevel == 1 || peopleInfo.disabilityLevel == '多重一级'">多重一级</span>
                <span v-if="peopleInfo.disabilityLevel == 2 || peopleInfo.disabilityLevel == '多重二级'">多重二级</span>
                <span v-if="peopleInfo.disabilityLevel == 3 || peopleInfo.disabilityLevel == '精神一级'">精神一级</span>
                <span v-if="peopleInfo.disabilityLevel == 4 || peopleInfo.disabilityLevel == '精神二级'">精神二级</span>
                <span v-if="peopleInfo.disabilityLevel == 5 || peopleInfo.disabilityLevel == '精神三级'">精神三级</span>
                <span v-if="peopleInfo.disabilityLevel == 6 || peopleInfo.disabilityLevel == '视力一级'">视力一级</span>
                <span v-if="peopleInfo.disabilityLevel == 7 || peopleInfo.disabilityLevel == '视力二级'">视力二级</span>
                <span v-if="peopleInfo.disabilityLevel == 8 || peopleInfo.disabilityLevel == '视力三级'">视力三级</span>
                <span v-if="peopleInfo.disabilityLevel == 9 || peopleInfo.disabilityLevel == '视力四级'">视力四级</span>
                <span v-if="peopleInfo.disabilityLevel == 10 || peopleInfo.disabilityLevel == '听力一级'">听力一级</span>
                <span v-if="peopleInfo.disabilityLevel == 11 || peopleInfo.disabilityLevel == '听力二级'">听力二级</span>
                <span v-if="peopleInfo.disabilityLevel == 12 || peopleInfo.disabilityLevel == '听力三级'">听力三级</span>
                <span v-if="peopleInfo.disabilityLevel == 13 || peopleInfo.disabilityLevel == '听力四级'">听力四级</span>
                <span v-if="peopleInfo.disabilityLevel == 14 || peopleInfo.disabilityLevel == '言语一级'">言语一级</span>
                <span v-if="peopleInfo.disabilityLevel == 15 || peopleInfo.disabilityLevel == '言语二级'">言语二级</span>
                <span v-if="peopleInfo.disabilityLevel == 16 || peopleInfo.disabilityLevel == '肢体一级'">肢体一级</span>
                <span v-if="peopleInfo.disabilityLevel == 17 || peopleInfo.disabilityLevel == '肢体二级'">肢体二级</span>
                <span v-if="peopleInfo.disabilityLevel == 18 || peopleInfo.disabilityLevel == '肢体三级'">肢体三级</span>
                <span v-if="peopleInfo.disabilityLevel == 19 || peopleInfo.disabilityLevel == '肢体四级'">肢体四级</span>
                <span v-if="peopleInfo.disabilityLevel == 20 || peopleInfo.disabilityLevel == '智力一级'">智力一级</span>
                <span v-if="peopleInfo.disabilityLevel == 21 || peopleInfo.disabilityLevel == '智力二级'">智力二级</span>
                <span v-if="peopleInfo.disabilityLevel == 22 || peopleInfo.disabilityLevel == '智力三级'">智力三级</span>
                <span v-if="peopleInfo.disabilityLevel == 23 || peopleInfo.disabilityLevel == '智力四级'">智力四级</span>
                <!-- <el-select v-model="peopleInfo.disabilityLevel"  placeholder="请选择">
                    <el-option
                    disabled
                    v-for="item in canjiList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select> -->
              </p>
            </div>
          </div>
          <div class="info-item">
            <div  style="display:flex;justify-content: space-around; height: 220px">
              <div style=" width: 30%">
                <p style="text-align:center">帮扶信息</p>
                <div style="height:190px;background: #162A5B;">
                  {{ peopleInfo.assistanceProgram }}
                </div>
              </div>
              <div style=" width: 30%">
                <p style="text-align:center">社区活动</p>
                <div style="height:190px;background: #162A5B;">
                  <div class="activeList2">
                    <div class="ac-title2" style="display: flex">
                      <div style="width: 50px">序号</div>
                      <div style="flex: 1">活动类型</div>
                      <div style="flex: 1">活动名称</div>
                    </div>
                    <div
                        class="houseContent"
                        style="height: 620px; overflow: scroll"
                      >
                      <vue-seamless-scroll
                        :style="{
                          height: this.scrollHeight + 'px',
                        }"
                        :data="tableActive3"
                        :class-option="defaultOption"
                        class="warp-content"
                      >
                        <div
                          class="ac-item"
                          style="display: flex"
                          v-for="(item, index) in tableActive3"
                          :key="index"
                          @click="getactiveInfo(item)"
                        >
                          <div style="width: 50px">{{ index + 1 }}</div>
                          <div
                            style="
                              flex: 1;
                              white-space: nowrap;
                              overflow: hidden;
                              text-overflow: ellipsis;
                            "
                          >
                            <span v-if="item.type == 1">图文</span>
                            <span v-if="item.type == 2">视频</span>
                          </div>
                          <div style="flex: 1;width: 160px; overflow: hidden; text-overflow:ellipsis; white-space: nowrap;">
                            <el-tooltip class="item" effect="dark" :content="item.name" placement="top">
                              <span>{{ item.name }}</span>
                            </el-tooltip>
                              
                              
                          </div>
                        </div>
                      </vue-seamless-scroll>
                    </div>
                  </div>
                </div>
              </div>
              <div style=" width: 30%">
                <p style="text-align:center">活动计划</p>
                <div style="height:190px;background: #162A5B;">
                  <div class="activeList2">
                    <div class="ac-title2" style="display: flex">
                      <div style="width: 50px">序号</div>
                      <div style="flex: 1">活动名称</div>
                      <div style="flex: 1">活动内容</div>
                      <div style="flex: 1">活动时间</div>
                    </div>
                    <div
                        class="houseContent"
                        style="height: 620px; overflow: scroll"
                      >
                      <vue-seamless-scroll
                        :style="{
                          height: this.scrollHeight + 'px',
                        }"
                        :data="tablePlan3"
                        :class-option="defaultOption"
                        class="warp-content"
                      >
                        <div
                          class="ac-item"
                          style="display: flex"
                          v-for="(item, index) in tablePlan3"
                          :key="index"
                          
                        >
                          <div style="width: 50px">{{ index + 1 }}</div>
                          <div style="flex: 1;width: 160px; overflow: hidden; text-overflow:ellipsis; white-space: nowrap;">{{ item.name }}</div>
                          <div style="flex: 1;width: 160px; overflow: hidden; text-overflow:ellipsis; white-space: nowrap;">{{ item.content }}</div>
                          <div style="flex: 1;width: 160px; overflow: hidden; text-overflow:ellipsis; white-space: nowrap;">{{ item.activityTime }}</div>
                        </div>
                      </vue-seamless-scroll>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <span class="close-info" @click="showInfoPer4 = false">×</span>
        </div>
      </div>
  </div>
</template>

<script>
// import baseURL from "@/api/baseURL"
import request from "@/utils/request.js"

export default {
  name: "visualized",
  data() {
    return {
      isLoading: false,
      targetName:"",
      peopleList:{
        age1:"0",
        age2:"0",
        age3:"0",
        age4:"0",
        age5:"0",
        tkType:"0",
        dbType:"0",
        lcbtType:"0"
      },
      listArea:[],
      changzhu:'138784',
      huji:"58802",
      showInfoPer1: false, //人员信息弹窗
      showInfoPer2: false,
      showInfoPer3: false,
      showInfoPer4: false,
      peopleInfo:{},
      peopleLists:[],
      areaList:[],
      markers:[],
      markerss:[],
      image:"",
      communityList:[
        {
          id: 140,
          longitude: 118.603045,
          latitude: 30.071066,
          name: "华阳镇",
          // address: "江苏省南京市浦口区江浦街道",
        },
        {
          id: 141,
          longitude:  118.550877,
          latitude: 29.994572,
          name: "临溪镇",
          // address: "南京市浦口区白马路8号",
        },
        {
          id: 142,
          longitude:  118.535604,
          latitude: 30.152058,
          name: "长安镇",
          // address: "南京市浦口区白马路8号",
        },
        {
          id: 143,
          longitude:  118.456584,
          latitude: 30.132008,
          name: "上庄镇",
          // address: "南京市浦口区白马路8号",
        },
        {
          id: 144,
          longitude:  118.653693,
          latitude: 30.157671,
          name: "扬溪镇",
          // address: "南京市浦口区白马路8号",
        },
        {
          id: 145,
          longitude:  118.741003,
          latitude: 30.144193,
          name: "伏岭镇",
          // address: "南京市浦口区白马路8号",
        },
        {
          id: 146,
          longitude:  118.744557,
          latitude: 30.26596,
          name: "金沙镇",
          // address: "南京市浦口区白马路8号",
        },
        {
          id: 147,
          longitude:  118.653363,
          latitude: 30.062743,
          name: "瀛洲镇",
          // address: "南京市浦口区白马路8号",
        },
        {
          id: 148,
          longitude:  118.615393,
          latitude: 30.201332,
          name: "板桥头乡",
          // address: "南京市浦口区白马路8号",
        },
        {
          id: 149,
          longitude:  118.82345,
          latitude: 30.242943,
          name: "家朋乡",
          // address: "南京市浦口区白马路8号",
        },
        {
          id: 150,
          longitude:  118.875031,
          latitude: 30.197045,
          name: "家朋乡",
          // address: "南京市浦口区白马路8号",
        },
      ]
    }
  },
  created(){
    this.$nextTick(() => {
      this.loadMap().then(() => {
        this.getDistrict()
        this.showditu()
      })
    })
    // this.getHealth()
    // this.getAgePercent()
    // this.oldNums()
    // this.showditu()
  },
  mounted() {
    this.getolder()
    // this.loadMap()
    this.showditu()
    this.getHealth()
    this.oldNums()
    this.getAgePercent()
    
  },
  methods:{
    //统计年龄段老人数
    getolder(){
      this.$http.request({
        url:"ypt/admin/jixi/customer/info/findAgeCount",
        method:"POST",
        data:{}
      }).then((res) =>{
        if(res.code == 200){
          if(res.content){
            this.peopleList = res.content
          }
          console.log(res.content);
        }
      })
    },
    //老人打点
    getoldPeople(val){
      this.$http.request({
        url:"ypt/admin/jixi/customer/info/findList",
        method:"POST",
        data:{
          ageFlag:val,
          pageNo:1,
          pageSize:-1,
        }
      }).then((res) =>{
        if(res.code == 200){
          if(res.content){
            this.map.remove(this.markerss)
            this.markerss = []
            this.peopleLists = []
            res.content.list.forEach((item)=>{
              if(item.id && item.longitude && item.latitude){
                this.peopleLists.push({
                  id:item.id,
                  name:item.customerName,
                  age:item.age,
                  longitude:item.longitude,
                  latitude:item.latitude,
                  phone:item.familyPhone,
                  sex:item.gender,
                  censusRegister:item.address
                })
              }
            })
            console.log(this.peopleLists);
            this.image = require("./assets/big/bai.png")
            this.renderMapMarkers(this.peopleLists,1)
          }
        }
      })
    },
    //健康分析
    async getHealth() {
      const myChart = this.$echarts.init(
        document.getElementById("healthPercent")
      );
      var option;
      option = {
        tooltip: {
          trigger: "item",
          // formatter: function (params) {
          //   return `${params.data.name}<br/>人数：${params.data.value}`;
          // },
        },
        color: [
          "#F21B62",
          "#7FD42D",
          "#22F7FF",
          "#0F5BF5",
          "#D800FF",
          "#2372BE",
          "#FFB026",
        ],
        // color: ["#F21B62", "#0F5BF5", "#2372BE", "#FFB026"],
        calculable: true,
        series: [
          {
            name: "访问来源",
            type: "pie",
            radius: "50%",
            center: ["50%", "30%"],
            label: {
              normal: {
                position: "inner",
                show: true,
                textStyle: {
                  fontSize: 12, //文字的字体大小
                },
                formatter: "{c}",
              },
            },
            data: [
              { value: 1749, name: "高血压" },
              { value: 417, name: "脑血管疾病" },
              { value: 10, name: "肾脏疾病" },
              { value: 744, name: "糖尿病" },
              { value: 34, name: "血管疾病" },
              { value: 2, name: "心脏病" },
              { value: 1, name: "眼部疾病" },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      option && myChart.setOption(option);
    },
    // 年龄百分比
    async getAgePercent() {
      const myChart = this.$echarts.init(document.getElementById("agePercent"));
      var option;
      option = {
        tooltip: {
          trigger: "item",
        },
        color: ["#0F5BF5", "#7FD42D", "#F21B62", "#FFB026"],
        series: [
          {
            name: "年龄段",
            type: "pie",
            radius: [30, 40],
            center: ["35%", "30%"],
            data: [
              { value: 1170, name: "60-64岁" },
              {
                value: 59,
                name: "60-89岁",
              },
              {
                value: 17,
                name: "95-99岁以上",
              },
              {
                value: 1,
                name: "100岁以上",
              },
            ],
          },
        ],
      };
      option && myChart.setOption(option);
    },
    // 老年人口数量
    async oldNums() {
      const myChart = this.$echarts.init(document.getElementById("oldNums"));
      var option;
      option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        color: ["#0F5BF5", "#F21B62"],
        legend: {
          icon: "circle",
          data: ["男", "女"],
          right: "0",
          top: "20",
          textStyle: {
            fontSize: 12,
            color: "#fff",
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: [
                "华阳镇",
                "临溪镇",
                "长安镇",
                "上庄镇",
                "扬溪镇",
                "伏岭镇",
                "金沙镇",
                "瀛洲镇",
                "板桥头乡",
                "家朋乡",
                "荆州乡",
            ],
            axisLabel: {
              interval: 0,
              rotate: 65,
            },
            axisLine: {
              lineStyle: {
                type: "solid",
                color: "#fff", //左边线的颜色
                width: "1", //坐标线的宽度
              },
            },
            axisTick: {
              alignWithLabel: true,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLine: {
              lineStyle: {
                type: "solid",
                color: "#fff", //左边线的颜色
                width: "1", //坐标线的宽度
              },
            },
          },
        ],
        series: [
          {
            name: "男",
            type: "bar",
            stack: "人数",
            emphasis: {
              focus: "series",
            },
            barWidth: 20,
            // data: mData,
            data: [
                32681, 3634, 5917, 4165, 3867, 5291, 2571, 3104, 3402, 3322,
                2339,
            ],
            barGap: "0",
            label: {
              normal: {
                show: true,
                formatter: "{c}",
                align: "center",
                verticalAlign: "middle",
                rotate: 90,
                position: "top",
                distance: -24,
                textStyle: {
                  color: "#fff",
                  fontSize: 14,
                },
              },
            },
          },
          {
            name: "女",
            type: "bar",
            stack: "人数",
            emphasis: {
              focus: "series",
            },
            // data: fData,
            data: [
                33412, 3347, 5286, 3744, 3452, 4476, 2299, 2948,  2832,  2900,2180,
            ],
            barGap: "0",
            barWidth: 20,
            label: {
              normal: {
                show: true,
                formatter: "{c}",
                align: "center",
                verticalAlign: "middle",
                rotate: 90,
                position: "top",
                distance: -24,
                textStyle: {
                  color: "#fff",
                  fontSize: 14,
                },
              },
            },
          },
          {
            //新的一个柱子 注意不设stack
            name: "总数",
            type: "bar",
            barGap: "0%", // 左移100%，stack不再与上面两个在一列
            barWidth: 9,
            label: {
              normal: {
                show: true,
                barWidth: 0,
                formatter: "{c}",
                align: "center",
                verticalAlign: "middle",
                rotate: 90,
                position: "top",
                color: "rgba(128, 128, 128, 0)",
                background: "rgba(128, 128, 128, 0),",
                distance: 25,
                left: "-30",
                textStyle: {
                  color: "#fff",
                  fontSize: 14,
                },
              },
            },
            data: [67705,6981,11203,7909,7322,9767,4870,6052,6234,6222,4519,],
            // data: this.targetId ? allnumber : totalData,
          },
        ],
      };
      option && myChart.setOption(option);
    },
    async showditu() {
      this.map.remove(this.markers)
      this.markers = []
      this.image = require("./assets/big/f1.png")
      this.renderMapMarker(this.communityList)
    },
    loadMap() {
      //地图加载
      return new Promise((resolve, reject) => {
        this.map = new AMap.Map("container", {
          resizeEnable: true,
          mapStyle: "amap://styles/darkblue",
          zoom: 9,
          center: [118.930934, 30.199045],
        })
        resolve()
      })
    },
    getDistrict(name = "341824", params = null) {
      let self = this
      // return new Promise((resolve, reject) => {
      var opts = {
        subdistrict: 1, //返回下一级行政区
        extensions: "all",
        showbiz: false, //最后一级返回街道信息
      }
      let district = new AMap.DistrictSearch(opts)

      try {
        self.map.remove(self.marker)
      } catch (err) {
        console.log(err)
      }

      self.marker = new AMap.Marker()
      district.search(name, (status, result) => {
        if (status == "complete") {
          let areaList = []
          result.districtList[0].districtList.forEach((item) => {
            console.log(item,'下次code')
            areaList.push({
              adcode: item.adcode,
              name: item.name,
            })
          })
          areaList[0].color = "#24609C"
          areaList[1].color = "#467399"
          areaList[2].color = "#0C2FA0"
          areaList[3].color = "#3769A6"
          areaList[4].color = "#22598D"
          areaList[5].color = "#326A9D"
          areaList[6].color = "#0C2FA0"
          areaList[7].color = "#2568A2"
          areaList[8].color = "#134CA2"
          areaList[9].color = "#183B77"
          areaList[10].color = "#183B70"
          areaList[11].color = "#183B70"

          self.areaList = areaList
          self.drawArea()
        }
      })
    },
    drawArea() {
      for (let i = 0; i < this.areaList.length; i++) {
        // console.log(this.areaList,'2222')
        this.getArea(this.areaList[i].adcode, this.areaList[i].color)
      }
    },
    getArea(name, color) {
      // console.log(name, color)
      const self = this
      var opts = {
        subdistrict: 1, //返回下一级行政区
        extensions: "all",
        showbiz: false, //最后一级返回街道信息
      }
      let district = new AMap.DistrictSearch(opts)

      try {
        self.map.remove(self.marker)
      } catch (err) {
        console.log(err)
      }
      self.marker = new AMap.Marker()
      district.search(name, (status, result) => {
        if (status == "complete") {
          let bounds = result.districtList[0].boundaries
          self.polygons = []
          for (var i = 0, l = bounds.length; i < l; i++) {
            self.polygon = new AMap.Polygon({
              map: self.map,
              strokeWeight: 1,
              strokeColor: "#007CDB",
              fillColor: color,
              fillOpacity: 0.06,
              path: bounds[i],
            })
            self.polygons.push(self.polygon)
          }
          // self.map.setFitView() //地图自适应
        }
      })
    },
    renderMapMarker(data) {
        let self = this
        if(data.length){
          var endIcon = new AMap.Icon({
              size: new AMap.Size(49, 56),
              image: this.image,
              imageSize: new AMap.Size(38, 42),
          })
          data.forEach((item) => {
              console.log(item.longitude,item.latitude);
              let marker = new AMap.Marker({
                  position: [String(item.longitude),String(item.latitude)],
                  icon: endIcon,
              })
              self.markers.push(marker)
              // marker.on("mouseover", (e) => {})
              // marker.on("click", (e) => {})
          })
        }
        self.map.add(self.markers)
        self.map.setFitView(self.markers)
    },
    renderMapMarkers(data,type) {
        let self = this
        if(data.length){
          var endIcon = new AMap.Icon({
              size: new AMap.Size(49, 56),
              image: this.image,
              imageSize: new AMap.Size(38, 42),
          })
          data.forEach((item) => {
              console.log(item.longitude,item.latitude);
              let marker = new AMap.Marker({
                  position: [String(item.longitude),String(item.latitude)],
                  icon: endIcon,
              })
              self.markerss.push(marker)
              // marker.on("mouseover", (e) => {})
              marker.on("click", (e) => {
                if(type == 1) {
                  this.showInfoPer1 = true
                  // alert(item.name)
                  this.peopleInfo = item
                }else if(type == 2){
                  this.showInfoPer2 = true
                  this.peopleInfo = item
                }else if(type == 3){
                  this.showInfoPer3 = true
                  this.peopleInfo = item
                }else if(type == 4){
                  this.showInfoPer4 = true
                  this.peopleInfo = item
                }
              })
          })
        }
        self.map.add(self.markerss)
        self.map.setFitView(self.markerss)
    },
    gethelpPeople(val){
      this.$http.request({
        url:"ypt/admin/jixi/customer/info/findList",
        method:"POST",
        data:{
          customerFlag:val,
          pageNo:1,
          pageSize:-1,
        }
      }).then((res) =>{
        if(res.code == 200){
          if(res.content){
            this.map.remove(this.markerss)
            this.markerss = []
            this.peopleLists = []
            res.content.list.forEach((item)=>{
              if(item.id && item.longitude && item.latitude){
                 this.peopleLists.push({
                  id:item.id,
                  name:item.customerName,
                  age:item.age,
                  longitude:item.longitude,
                  latitude:item.latitude,
                  phone:item.familyPhone,
                  sex:item.gender,
                  censusRegister:item.address
                })
              }
            })
            if(val == 1){
              this.image = require("./assets/big/kun.png")
              this.renderMapMarkers(this.peopleLists,2)
            }else if(val == 2){
              this.image = require("./assets/big/di.png")
              this.renderMapMarkers(this.peopleLists,3)
            }else if(val == 3){
              this.image = require("./assets/big/can.png")
              this.renderMapMarkers(this.peopleLists,4)
            }
            
          }
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
#container {
  position: absolute;
  left: 0;
  right: 0;
  top: 100px;
  bottom: 0;
  z-index: 1;
}
::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}
.tableBox /deep/ .el-table--fit{
        // padding: 20px;
        // background-color: #01117b;
        color: #85C2FF;
        border: 1px solid #3573AD;
}
 .tableBox /deep/  .el-table, .el-table__expanded-cell .is-center{
    background-color: #01117b;
    color: #85C2FF;
    border: 1px solid #3573AD;
}

 .tableBox /deep/ .el-table tr .is-center{
    background-color: #01117b!important;
    color: #85C2FF;
    border: 1px solid #3573AD;
}
 .tableBox /deep/  .el-table--enable-row-transition .el-table__body td, .el-table .cell .is-center{
    background-color: #01117b;
    color: #85C2FF;
    border: 1px solid #3573AD;
}
.close-info {
  color: #22f7ff;
  position: absolute;
  top: 20px;
  right: 20px;
  font-size: 30px;
  cursor: pointer;
}
.perInfoBox {
  background: rgba(7, 17, 27, 0.5);
  position: fixed;
  width: 100%;
  top: 0;
  bottom: 0;
  z-index: 9999;
}
.info-txt {
  position: relative;
  color: #fff;
  width: 50%;
  font-size: 14px;
  height: 90vh;
  overflow: scroll;
  margin: 10px auto;
  background: #002673;
}
.intitle {
  color: #22f7ff;
  font-size: 18px;
}

.info-item {
  border-bottom: 1px solid #085e98;
  padding: 10px 30px;
  line-height: 40px;
}
.info-item:first-child {
  line-height: 25px !important;
  padding: 20px 30px;
}
.area {
  display: flex;
  color: #fff;
  position: relative;
  right: 175px;
  top: 60px;
}
.area > div {
  cursor: pointer;
  font-size: 13px;
  padding: 10px 20px;
  background: rgba(26, 70, 247, 0.4);
  color: #eee;
  margin: 0 10px;
  border-radius: 2px;
}
.aactive {
  background: #1a46f7 !important;
}
.top-menu {
  color: #fff;
  font-size: 13px;
  height: 80px;
  z-index: 99;
  position: absolute;
  top: 20px;
  width: 100%;
  justify-content: space-around;
}
.top-menu > div {
  background: rgba(1, 21, 141, 0.6);
  border: 1px solid rgba(34, 236, 255, 1);
}
.top-menu > div p {
  margin: 12px 0;
}
.l1 {
  background: rgba(26, 70, 247, 0.77);
}
.l1,
.l2,
.l3 {
  width: 20%;
  align-items: center;
  width: 20%;
  justify-content: space-around;
}
.l2,
.l3 {
  text-align: center !important;
}
.l1 > div {
  text-align: right;
}
p > img {
  width: 20px;
  margin-right: 10px;
}
.nums {
  font-size: 20px;
  color: #ffa200;
  font-weight: bold;
}
.color-l {
  color: #2372be;
}
.color-z {
  color: #F21B62;
}
.color-h {
  color: #ffa200;
}
.color-q {
  color: #a5fb52;
}
.color-g {
  color: #22f7ff;
}
.flex-item {
  display: flex;
}
.log-Main {
  background: url("./assets/big/data_bg.png") repeat;
  overflow-x: hidden;
  width: 100%;
}
.realTop {
  position: absolute;
  top: 0px;
  z-index: 2;
  background: url("./assets/big/oldTitle1.png");
  background-size: cover;
  margin: 0 auto;
  height: 90px;
  width: 100%;
}
.oldBox {
  border: 1px solid rgba(34, 236, 255, 1);
  background: #01117b;
  margin-top: 28px;
  position: relative;
  min-height: 35px;
  .leftTitle {
    position: absolute;
    width: 100%;
    height: 35px;
    background: url("./assets/big/titleLeft.png") no-repeat center;
    text-align: center;
    font-size: 17px;
    line-height: 35px;
    color: #22f7ff;
    top: -17px;
  }
}

#pieChart {
  width: 350px;
  height: 300px;
}
.party-map {
  width: 100%;
  /* height: calc(100vh - 20px); */
  height: 100vh;
}
.colorOrange {
  color: #ffa200;
}
.colorPink {
  color: #d800ff;
}
.colorCycan {
  color: #a5fb52;
}
.colorRed {
  color: #f21b62;
}
.colorBlue {
  color: #22f7ff;
}
.oldLeft {
  position: absolute;
  top: 100px;
  left: 20px;
  width: 990px;
  height: 116px;
  background: rgba(1, 21, 141, 0.6);
  border: 1px solid rgba(34, 236, 255, 1);
  .oldLeftBox {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 116px;
    .oldLeftItem {
      text-align: center;
      flex: 1;
      .name {
        color: #fff;
        font-size: 18px;
        img {
          width: 22px;
          height: 22px;
          margin-right: 5px;
        }
      }
      .num {
        color: #ffa200;
        margin-top: 10px;
        font-size: 34px;
        margin-left: 30px;
      }
    }
  }
}
.oldRight {
  z-index: 1000;
  position: absolute;
  top: 120px;
  right: 20px;
  width: 850px;
  .rightNumBox {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 114px;
    text-align: center;
    .rightNumBoxItem {
      margin-right: 12px;
      height: 112px;
      background: rgba(1, 21, 141, 0.6);
      border: 1px solid rgba(34, 236, 255, 1);
      flex: 1;
      .name {
        font-size: 26px;
        padding-top: 20px;
      }
      .num {
        padding-top: 7px;
        color: #22f7ff;
        font-size: 15px;
      }
    }
    .rightNumBoxItem3 {
      flex: 3;
      display: flex;
      align-items: center;
      height: 112px;
      justify-content: center;
      background: rgba(1, 21, 141, 0.6);
      border: 1px solid rgba(34, 236, 255, 1);
      .item3It {
        flex: 1;
        .name {
          color: #f5f5f5;
          font-size: 18px;
        }
        .num {
          font-weight: bold;
          font-size: 28px;
        }
      }
    }
  }
}
#oldNums {
  width: 100%;
  height: 40vh;
}
.percentBox {
  padding-top: 20px;
  display: flex;
  .percentItem {
    flex: 1;
    .percentTitle {
      color: #00d2ff;
      font-size: 16px;
      padding: 10px 0 0 30px;
    }
    #sexPercent {
      width: 100%;
      height: 22vh;
    }
    #agePercent {
      width: 100%;
      height: 22vh;
    }
    #healthPercent {
      width: 100%;
      height: 22vh;
    }
    .mallNote {
      margin: -60px 0 0 15px;
      padding-bottom: 20px;
      font-size: 12px;
      ul {
        display: flex;
        li {
          flex: 1;
          padding: 5px 0;
        }
      }
      .sexInfos {
        padding-left: 30px;
      }
      .icon {
        display: inline-block;
        width: 12px;
        height: 12px;
        border-radius: 50%;
      }
      .icon1 {
        background: #0f5bf5;
      }
      .icon2 {
        background: #73c0de;
      }
      .icon3 {
        background: #7fd42d;
      }
      .icon4 {
        background: #f21b62;
      }
      .icon5 {
        background: #ffb026;
      }
      .num,
      .name {
        display: inline-block;
        text-align: right;
        color: #22f7ff;
        margin: 0 10px 0 8px;
      }
      .name1 {
        width: 30px !important;
      }
      .ml25 {
        margin-left: 25px;
      }
      .num {
        width: 40px;
      }
    }
  }
}

.newDiv {
  position: absolute;
  background: red;
  color: white;
  width: 100px;
  height: 50px;
}
.mapOpen {
  display: flex;
  width: 700px;
  .mapImg {
    width: 180px;
    height: 180px;
    margin-right: 12px;
  }
  .mapFlex {
    flex: 1;
    color: #474747;
    font-size: 30px;
    .address,
    .info {
      padding-top: 12px;
    }
  }
}
.quanp {
  position: absolute;
  top: 20px;
  right: 10px;
  z-index: 100;
  button {
    padding: 10px;
  }
}
.modelfy {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background-size: 100% 100%;
}
.shubaio :hover {
  cursor: pointer;
}
#box {
  width: 100px;
  height: 100px;
  background-color: coral;
  /*保证div能移动，一定要添加定位*/
  position: absolute;
  cursor: move;
  top: 242;
  left: 394;
}
.activeList2 {
  color: #fff;
  flex: 1;
  text-align: center;
  font-size: 14px;
  height: 199px;
  overflow: scroll;
}
.ac-item {
  padding: 15px 10px;
  border-bottom: 1px solid #0f5bf5;
  font-size: 13px;
  cursor: pointer;
}
.ac-title2{
  color: #1a46f7;
  font-size: 16px;
  border-bottom: 2px solid #0f5bf5;
  position: relative;
  z-index: 99;
  background: #01117b;
}
</style>
<style lang="less">
.amap-marker {
  transform: rotate(0deg) !important;
}
</style>

